import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export const StyledContainer = styled(Box)({
  height: '100%',
  width: '100%',
  border: 'none',
  position: 'relative'
});

export const StyledBox = styled(Box)({
  border: 'none',
  height: '100%',
  width: '100%',
  borderRadius: '5px'
});

export const StyledLoader = styled(CircularProgress)({
  position: 'absolute',
  top: 'calc(50% - 30px)',
  left: 'calc(50% - 30px)'
});



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpDocViewer/styles.js